import { useState } from 'react';
import { Category } from 'types/entity/category';
import { Reference } from 'types/reference';
import { Tile } from '../../types';
import HeaderNavigationButtonDesktop from './header-navigation-button/HeaderNavigationButtonDesktop';
import MenuDropdown from './menu-dropdown/MenuDropdown';

export interface Props {
  links: Category[];
  tiles: Tile[];
  col1Label: string;
  col1Links: { label: string; reference: Reference; linkCategoryKey: string }[];
}

const HeaderNavigationDesktop: React.FC<Props> = ({ links, tiles, col1Label, col1Links }) => {
  const [activeCategory, setActiveCategory] = useState<Category>();

  const showSubMenu = (category?: Category) => {
    setActiveCategory(category);
  };
  const hideSubMenu = () => {
    setActiveCategory(undefined);
  };

  const handleMouseIn = (category: Category) => {
    showSubMenu(category);
  };

  const handleMouseOut = () => {
    hideSubMenu();
  };

  return (
    links && (
      <div className="hidden size-full items-center pl-11 md:flex" onMouseLeave={handleMouseOut}>
        <div className="flex w-fit justify-start gap-10">
          {links.map((link) => (
            <div key={link?.categoryId} onMouseEnter={() => handleMouseIn(link)}>
              <HeaderNavigationButtonDesktop
                show={link.categoryId === activeCategory?.categoryId}
                link={link}
                updateSubMenu={hideSubMenu}
              />
            </div>
          ))}
        </div>
        <MenuDropdown
          categoryKey={activeCategory?.categoryKey}
          show={!!activeCategory && activeCategory.descendants && activeCategory.descendants.length > 0}
          onClick={hideSubMenu}
          categories={activeCategory?.descendants ?? []}
          tileContent={tiles}
          col1Label={col1Label}
          col1Links={col1Links}
        />
      </div>
    )
  );
};

export default HeaderNavigationDesktop;
